import { Link, useLocation } from "react-router-dom";
import {
  FaChartBar,
  FaClipboardList,
  FaPlus,
  FaBuilding,
  FaUser,
} from "react-icons/fa";
import { useUser } from "../../../context/UserContext";
import UserAvatar from "../../common/UserAvatar";

const BottomNav = () => {
  const location = useLocation();
  const { user } = useUser();

  const isActive = (path, exact) => {
    if (exact) {
      return location.pathname === path;
    }
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const NavItem = ({ path, exact, icon: Icon, name }) => {
    const active = isActive(path, exact);
    return (
      <Link
        to={path}
        className={`flex flex-col items-center justify-center flex-1 h-full transition-colors duration-200 ${
          active ? "text-slate-900" : "text-slate-400 hover:text-slate-600"
        }`}
      >
        <Icon className="w-5 h-5" />
        <span className="text-[10px] mt-1 font-medium leading-none">
          {name}
        </span>
      </Link>
    );
  };

  const activeNewQuote = isActive("/quotes/new");

  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-lg lg:hidden pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center h-16 px-2">
        {/* Left section */}
        <NavItem path="/" exact icon={FaChartBar} name="Dashboard" />
        <NavItem path="/quotes" exact icon={FaClipboardList} name="Cotações" />

        {/* Center - Nova Cotação */}
        <Link
          to="/quotes/new"
          className="flex flex-col items-center justify-center flex-1 h-full"
        >
          <div
            className={`w-12 h-12 rounded-full flex items-center justify-center -mt-4 shadow-md transition-all duration-200 ${
              activeNewQuote
                ? "bg-accent scale-110"
                : "bg-accent hover:bg-accent-hover"
            }`}
          >
            <FaPlus className="w-5 h-5 text-white" />
          </div>
          <span className="text-[10px] mt-0.5 font-medium leading-none text-accent">
            Nova
          </span>
        </Link>

        {/* Right section */}
        <NavItem path="/projects" icon={FaBuilding} name="Obras" />
        <Link
          to="/profile"
          className={`flex flex-col items-center justify-center flex-1 h-full transition-colors duration-200 ${
            isActive("/profile") ? "text-slate-900" : "text-slate-400 hover:text-slate-600"
          }`}
        >
          <UserAvatar
            src={user?.picture}
            alt="Perfil"
            className={`w-6 h-6 rounded-full object-cover ${
              isActive("/profile") ? "ring-2 ring-slate-900" : ""
            }`}
            fallback={<FaUser className="w-5 h-5" />}
          />
          <span className="text-[10px] mt-1 font-medium leading-none">
            Perfil
          </span>
        </Link>
      </div>
    </nav>
  );
};

export default BottomNav;
